class SearchModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.searchField = this.querySelector('#search-field');
    this.searchForm = this.querySelector('.search-form');
    this.searchResultWrapper = this.querySelector('.search-result-wrapper');
    this.spinner = this.querySelector('.search-spinner') || this.querySelector('#search-spinner');
    this.noProductFound = this.querySelector('.no-product-found');
    this.removeBtn = this.querySelector('.search-remove, #search-remove');
    this.searchQuery = this.searchField.dataset.type || 'product,page,collection,article'

    // Result containers
    this.productsBlock = this.querySelector('.show-search-products');
    this.collectionsBlock = this.querySelector('.show-search-collections');
    this.pagesBlock = this.querySelector('.show-search-pages');
    this.blogsBlock = this.querySelector('.show-search-blogs');

    // Result lists
    this.productsList = this.productsBlock?.querySelector('ul');
    this.collectionsList = this.collectionsBlock?.querySelector('ul');
    this.pagesList = this.pagesBlock?.querySelector('ul');
    this.blogsList = this.blogsBlock?.querySelector('ul');

    this.debounceTimeout = null;

    this.searchField?.addEventListener('keyup', (e) => {
      clearTimeout(this.debounceTimeout);
      const value = e.target.value;
      this.debounceTimeout = setTimeout(() => {
        if (value && value.length > 0) {
          this.getProducts(value);
        } else {
          this.hideSearch();
        }
      }, 500);
    });

    this.removeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.clearSearch();
      this.hideSearch();
    });

    this.searchForm?.addEventListener('submit', (e) => {
      // Let the form submit normally
    });
  }

  getProducts(query) {
    if (this.spinner) this.spinner.classList.add('show-spinner');
    if (this.noProductFound) this.noProductFound.style.display = 'none';
    this.searchResultWrapper?.classList.add('show');
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${this.searchQuery}&resources[options][unavailable_products]=last`)
      .then(res => res.json())
      .then(data => {
        this.loadProducts(data);
      });
  }

  loadProducts(data) {
    // Clear all lists
    if (this.productsList) this.productsList.innerHTML = '';
    if (this.collectionsList) this.collectionsList.innerHTML = '';
    if (this.pagesList) this.pagesList.innerHTML = '';
    if (this.blogsList) this.blogsList.innerHTML = '';

    // Hide all blocks initially
    if (this.productsBlock) this.productsBlock.style.display = 'none';
    if (this.collectionsBlock) this.collectionsBlock.style.display = 'none';
    if (this.pagesBlock) this.pagesBlock.style.display = 'none';
    if (this.blogsBlock) this.blogsBlock.style.display = 'none';

    let found = false;
    // Products
    if (data.resources?.results?.products?.length > 0 && this.productsBlock && this.productsList) {
      data.resources.results.products.forEach(product => {
        const li = this.createProductLi(product);
        this.productsList.appendChild(li);
      });
      this.productsBlock.style.display = '';
      found = true;
    }
    // Collections
    if (data.resources?.results?.collections?.length > 0 && this.collectionsBlock && this.collectionsList) {
      data.resources.results.collections.forEach(collection => {
        const li = this.createCollectionLi(collection);
        this.collectionsList.appendChild(li);
      });
      this.collectionsBlock.style.display = '';
      found = true;
    }
    // Pages
    if (data.resources?.results?.pages?.length > 0 && this.pagesBlock && this.pagesList) {
      data.resources.results.pages.forEach(page => {
        const li = this.createPageLi(page);
        this.pagesList.appendChild(li);
      });
      this.pagesBlock.style.display = '';
      found = true;
    }
    // Blogs/Articles
    if (data.resources?.results?.articles?.length > 0 && this.blogsBlock && this.blogsList) {
      data.resources.results.articles.forEach(article => {
        const li = this.createBlogLi(article);
        this.blogsList.appendChild(li);
      });
      this.blogsBlock.style.display = '';
      found = true;
    }

    if (!found && this.noProductFound) {
      this.noProductFound.style.display = 'block';
    } else if (this.noProductFound) {
      this.noProductFound.style.display = 'none';
    }
    if (this.spinner) this.spinner.classList.remove('show-spinner');
  }

  createProductLi(product) {
    const li = document.createElement('li');
    li.className = 'search-result-product';
    li.innerHTML = `
      <a href="${product.url}" rel="nofollow">
        <div class="search-results">
          <div class="img-box product-img ${product.featured_image?.url == null && "hidden"}">
            <img src="${product.featured_image?.url}" alt="${product.title}" width="auto" height="auto">
          </div>
          <div class="product-details item-details">
            <h3 class="title">${product.title}</h3>
            <p class="price">${typeof Shopify !== 'undefined' ? Shopify.formatMoney(product.price) : ''}</p>
          </div>
        </div>
      </a>
    `;
    return li;
  }

  createCollectionLi(collection) {
    const li = document.createElement('li');
    li.className = 'search-result-collection';
    li.innerHTML = `
      <a href="${collection.url}" rel="nofollow">
        <div class="search-results">
          <div class="img-box ${collection.featured_image?.url == null && "hidden"}">
            <img src="${collection.featured_image?.url}" alt="${collection.title}" width="auto" height="auto">
          </div>
          <div class="item-details">
            <h3 class="title">${collection.title}</h3>
          </div>
        </div>
      </a>
    `;
    return li;
  }

  createPageLi(page) {
    const li = document.createElement('li');
    li.className = 'search-result-page';
    li.innerHTML = `
      <a href="${page.url}" rel="nofollow">
        <div class="search-results">
          <div class="item-details">
            <h3 class="title">${page.title}</h3>
          </div>
        </div>
      </a>
    `;
    return li;
  }

  createBlogLi(article) {
    const li = document.createElement('li');
    li.className = 'search-result-blog';
    const published = article.published_at ? new Date(article.published_at) : null;
    const publishedStr = published ? `${published.toLocaleString('default', { month: 'long' })} ${(published.getDate()).toString().padStart(2, '0')}, ${published.getFullYear().toString().substr(2,2)}` : '';
    // Truncate article.body to 100 characters and strip HTML tags
    function truncateHtml(html, maxLength) {
      const div = document.createElement('div');
      div.innerHTML = html || '';
      const text = div.textContent || div.innerText || '';
      return text.length > maxLength ? text.substring(0, maxLength) + '…' : text;
    }
    const truncatedBody = truncateHtml(article.body, 50);

    li.innerHTML = `
      <a href="${article.url}" rel="nofollow">
      <div class="search-results">
        <div class="img-box ${article.featured_image?.url == null && "hidden"}">
        <img src="${article.featured_image?.url}" alt="${article.title}" width="auto" height="auto">
        </div>
        <div class="item-details">
        <h3 class="title">${article.title}</h3>
        <span class="blog-meta">By <span class="blog-author">${article.author || ''}</span>, <span class="blog-published-date">${publishedStr}</span></span>
        <div class="blog-content">${truncatedBody}</div>
        </div>
      </div>
      </a>
    `;
    return li;
  }

  hideSearch() {
    this.searchResultWrapper?.classList.remove('show');
  }

  clearSearch() {
    if (this.searchField) this.searchField.value = '';
    if (this.productsList) this.productsList.innerHTML = '';
    if (this.collectionsList) this.collectionsList.innerHTML = '';
    if (this.pagesList) this.pagesList.innerHTML = '';
    if (this.blogsList) this.blogsList.innerHTML = '';
    if (this.noProductFound) this.noProductFound.style.display = 'none';
    this.hideSearch();
  }
}

if (!customElements.get('search-modal')) {
  customElements.define('search-modal', SearchModal);
}